"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeadCell = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var Typography_1 = require("../Typography");
var TableHeadCell = function (_a) {
    var leading = _a.leading, children = _a.children, className = _a.className, contentClassName = _a.contentClassName, align = _a.align, _b = _a.colSpan, colSpan = _b === void 0 ? 1 : _b, _c = _a["data-testid"], testId = _c === void 0 ? 'tableHeader' : _c, onClick = _a.onClick;
    var title = typeof children === 'string' ? ((0, jsx_runtime_1.jsx)(Typography_1.Overline, __assign({ as: "h4", color: "weaker", className: "squid-whitespace-nowrap" }, { children: children }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }));
    return ((0, jsx_runtime_1.jsx)("th", __assign({ "data-testid": testId, className: (0, classnames_1.default)(leading
            ? 'squid-pr-0 squid-max-w-min squid-pl-component-table-cell-padding-base squid-py-component-table-cell-padding-tight'
            : 'squid-px-component-table-cell-padding-tighter squid-py-component-table-cell-padding-tight', className), colSpan: colSpan, onClick: onClick }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('squid-flex squid-items-center squid-gap-component-table-cell-space-base', {
                'squid-justify-center': align === 'center',
                'squid-justify-start': !align || align === 'left',
                'squid-justify-end': align === 'right',
            }, contentClassName) }, { children: title })) })));
};
exports.TableHeadCell = TableHeadCell;
